export default __webpack_public_path__ + "static/media/trash_icon.e623b5a8.svg";